import React from "react";

const UserSettings = ({ userSettings, onSettingsChange }) => {
  return (
    <div className="global_cardbox inner_global_card">
      <div className="global_card_header">
        <div className="global_head_tag"><span>2</span> User Settings</div>
      </div>
      <div className="password_permission">
        <div className="row">
          <div className="col-12">
            <label className="cl-checkbox">
              <input
                type="checkbox"
                checked={userSettings.changePassword}
                onChange={(e) => onSettingsChange("changePassword", e.target.checked)} // ✅ Correct key
              />
              <span>Change Their Password</span>
            </label>
          </div>
          <div className="col-12">
            <label className="cl-checkbox">
              <input
                type="checkbox"
                checked={userSettings.accessSettings}
                onChange={(e) => onSettingsChange("accessSettings", e.target.checked)} // ✅ Correct key
              />
              <span>Access Personal Settings</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;
